/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */
import React from 'react';
import ReactDOM from 'react-dom';
import {Form, FormGroup, FormControl, ControlLabel} from 'react-bootstrap';
import {Glyphicon, Modal, Label, Button, Panel, ListGroup, ListGroupItem, Grid, Row, Col, Image, Nav, NavItem, Checkbox} from 'react-bootstrap';
import { Table } from 'react-bootstrap';
import ReactSpinner from 'react-spinjs';


export default class PinEditModal extends React.Component {
    constructor(props) {
        console.log("[PinEditModal] - initialisation");

        super(props);
        this.state = {
            pinType : 1,
            ledType : 1,
            safetyCircuit : 1,
            criticalFault : 1
        };

        this.handleTypeSelect = this.handleTypeSelect.bind(this);
        this.handleLedSelect = this.handleLedSelect.bind(this);
        this.handleSafetySelect = this.handleSafetySelect.bind(this);
        this.handleCriticalSelect = this.handleCriticalSelect.bind(this);
    }

    componentWillMount() {
      let origPin = this.props.originalPin;
      let pinType = 1 ;
      let ledType = 1;
      let safety = parseInt(origPin.safety, 10) || 1 ;
      let critical = parseInt(origPin.critical, 10) || 1 ;

      switch (origPin.type || "digital") {
        case "digital" :
            pinType = 1 ;
            switch (origPin.led || "W") {
              case "R" : ledType = 1 ; break ;
              case "G" : ledType = 2 ; break ;
              case "Y" : ledType = 3 ; break ;
              case "O" : ledType = 5 ; break ;
              default: ledType = 4;
            }
            break ;
        case "analogue" : pinType = 2 ; break ;
        case "voltage" : pinType = 3 ; break ;
        case "volts" : pinType = 3 ; break ;
        case "dip" : pinType = 4 ; break ;
      }

      console.log("[WillMount] - ORIGINAL PIN=", origPin) ;
      this.setState({
        pinType : pinType,
        ledType : ledType,
        safetyCircuit : safety,
        criticalFault : critical,
        voltageCheck : origPin.voltageCheck,
        voltCritical : origPin.voltCritical,
        newChannel: origPin.channel ? origPin.channel : "",
        localChannel : origPin.localpin ? origPin.localpin : "",
        newTitle: origPin.title ? origPin.title : "",
        newDesc: origPin.desc ? origPin.desc : "",
        newGroup: origPin.pinGroup ? origPin.pinGroup : this.props.pinGroupName,
        zeroOn : origPin.zeroOn ? origPin.zeroOn : false
      });
    }

    componentWillReceiveProps(nextProps) {
    }

    componentDidMount() {
      console.log("[PinEditModal] - componentDidMount");
      ReactDOM.findDOMNode(this.refs.firstInput).focus();
    }

    componentWillUnmount() {
    }

    isOkAllowed() {
      return this.state.newChannel && this.state.newTitle && this.state.newDesc;
    }

    okClicked() {
      let pinType = "" ;
      let ledType = null ;
      switch (this.state.pinType) {
        case 1 :
          pinType = "digital" ;
          switch (this.state.ledType) {
            case 1 : ledType = "R" ; break ;
            case 2 : ledType = "G" ; break ;
            case 3 : ledType = "Y" ; break ;
            case 4 : ledType = "W" ; break ;
            case 5 : ledType = "O" ; break ;
            default: ledType = "W";
          }
          break ;
        case 2 : pinType = "analogue" ; break ;
        case 3 : pinType = "voltage" ; break ;
        case 4 : pinType = "dip" ; break ;
        default: pinType = "digital";
      }

      this.props.onFinished({
          channel: this.state.newChannel,
          localpin : this.state.localChannel || this.state.newChannel,
          title: this.state.newTitle,
          desc: this.state.newDesc,
          type: pinType,
          safety : this.state.safetyCircuit,
          critical : this.state.criticalFault,
          voltageCheck : this.state.voltageCheck,
          voltCritical : this.state.voltCritical,
          direction: this.props.originalPin.direction,
          pinGroup : this.state.newGroup && this.state.newGroup !== "" ? this.state.newGroup : null,
          led : ledType,
          zeroOn : this.state.zeroOn
        });
    }

    handleTypeSelect(pt) {
      this.setState({pinType : pt});
    }

    handleLedSelect(led) {
      this.setState({ledType : led});
    }

    handleSafetySelect(ss) {
      this.setState({safetyCircuit : ss});
    }

    handleCriticalSelect(ss) {
        this.setState({criticalFault : ss});
    }

    render() {
        console.log("PIN STATE=", this.state) ;
        console.log("PIN STATE=", this.props.originalPin) ;

      return (
          <Modal show={true} onHide={()=>this.props.onFinished(null)}>
            <Modal.Header closeButton>
              <Modal.Title>{this.props.pinGroupName}: add/edit pin</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form horizontal>
                <FormGroup>
                  <Col sm={2}><ControlLabel>Pin #</ControlLabel></Col>
                  <Col sm={4}><FormControl type="text"
                    value={this.state.newChannel} ref='firstInput'
                    onChange={(e)=>this.setState({newChannel: e.target.value })}/></Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={2}><ControlLabel>Local PIN</ControlLabel></Col>
                  <Col sm={4}><FormControl type="text"
                    value={this.state.localChannel} ref='localInput'
                    onChange={(e)=>this.setState({localChannel: e.target.value })}/></Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={2}><ControlLabel>Type</ControlLabel></Col>
                  <Col sm={4}>
                  <Nav bsStyle="pills" activeKey={this.state.pinType} onSelect={this.handleTypeSelect} justified>
                      <NavItem eventKey={1} >Digital</NavItem>
                      <NavItem eventKey={2} >Analogue</NavItem>
                      <NavItem eventKey={3} >Voltage</NavItem>
                      <NavItem eventKey={4} >DIP</NavItem>
                  </Nav>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={2}><ControlLabel>Title</ControlLabel></Col>
                  <Col sm={4}><FormControl type="text"
                    value={this.state.newTitle}
                    onChange={(e)=>this.setState({newTitle: e.target.value })}/></Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={2}><ControlLabel>Description</ControlLabel></Col>
                  <Col sm={8}><FormControl type="text"
                    value={this.state.newDesc}
                    onChange={(e)=>this.setState({newDesc: e.target.value })}/></Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={2}><ControlLabel>PIN Group</ControlLabel></Col>
                  <Col sm={8}><FormControl type="text"
                    value={this.state.newGroup}
                    onChange={(e)=>this.setState({newGroup: e.target.value })}/></Col>
                </FormGroup>
                {this.state.pinType === 1 &&
                    <div>
                      <FormGroup>
                        <Col sm={2}><ControlLabel>Zero ON</ControlLabel></Col>
                        <Col sm={8}>
                         <Checkbox validationState="success" checked={this.state.zeroOn} onChange={(e)=>this.setState({zeroOn: e.target.checked })}>
                            A zero (0) output from board represents ON
                          </Checkbox>
                        </Col>
                      </FormGroup>
                      <FormGroup>
                        <Col sm={2}><ControlLabel>LED</ControlLabel></Col>
                        <Col sm={8}>
                          <Nav bsStyle="pills" activeKey={this.state.ledType} onSelect={this.handleLedSelect} justified>
                              <NavItem eventKey={1} >Red</NavItem>
                              <NavItem eventKey={2} >Green</NavItem>
                              <NavItem eventKey={3} >Yellow</NavItem>
                              <NavItem eventKey={4} >White</NavItem>
                              <NavItem eventKey={5} >Orange</NavItem>
                          </Nav>
                        </Col>
                      </FormGroup>
                      <FormGroup>
                        <Col sm={2}><ControlLabel>Safety Circuit</ControlLabel></Col>
                        <Col sm={8}>
                          <Nav bsStyle="pills" activeKey={this.state.safetyCircuit} onSelect={this.handleSafetySelect} justified>
                              <NavItem eventKey={1} >Not Applicable</NavItem>
                              <NavItem eventKey={2} >When ON</NavItem>
                              <NavItem eventKey={3} >When OFF</NavItem>
                          </Nav>
                        </Col>
                      </FormGroup>
                      <FormGroup>
                            <Col sm={2}><ControlLabel>Critical Fault</ControlLabel></Col>
                            <Col sm={8}>
                                <Nav bsStyle="pills" activeKey={this.state.criticalFault} onSelect={this.handleCriticalSelect} justified>
                                    <NavItem eventKey={1} >Not Applicable</NavItem>
                                    <NavItem eventKey={2} >When ON</NavItem>
                                    <NavItem eventKey={3} >When OFF</NavItem>
                                </Nav>
                            </Col>
                      </FormGroup>
                    </div>
                }
                {this.state.pinType === 3 &&
                    <div>
                      <FormGroup>
                        <Col sm={2}><ControlLabel>Safety Circuit</ControlLabel></Col>
                        <Col sm={8}>
                          <Nav bsStyle="pills" activeKey={this.state.safetyCircuit} onSelect={this.handleSafetySelect} justified>
                              <NavItem eventKey={1} >Not Applicable</NavItem>
                              <NavItem eventKey={2} >Less Than</NavItem>
                              <NavItem eventKey={3} >Equals</NavItem>
                              <NavItem eventKey={4} >More Than</NavItem>
                          </Nav>
                          <FormControl type="text"
                              value={this.state.voltageCheck}
                              onChange={(e)=>this.setState({voltageCheck: e.target.value })}/>
                        </Col>
                      </FormGroup>
                        <FormGroup>
                            <Col sm={2}><ControlLabel>Critical Fault</ControlLabel></Col>
                            <Col sm={8}>
                                <Nav bsStyle="pills" activeKey={this.state.criticalFault} onSelect={this.handleCriticalSelect} justified>
                                    <NavItem eventKey={1} >Not Applicable</NavItem>
                                    <NavItem eventKey={2} >Less Than</NavItem>
                                    <NavItem eventKey={3} >Equals</NavItem>
                                    <NavItem eventKey={4} >More Than</NavItem>
                                </Nav>
                                <FormControl type="text"
                                             value={this.state.voltCritical}
                                             onChange={(e)=>this.setState({voltCritical: e.target.value })}/>
                            </Col>
                        </FormGroup>
                    </div>
                }

              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={()=>this.props.onFinished(null)}>Cancel</Button>
              <Button bsStyle="success" disabled={!this.isOkAllowed()} onClick={()=>this.okClicked()}>Ok</Button>
            </Modal.Footer>
          </Modal>
      );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/products/PinEditModal.react.js